import { RootState } from 'app/store';
import { createSelector } from 'reselect';
import { getCategoryName } from '../categories.utils';
import categoriesAdapter from './categories.adapter';

export const {
  selectAll: selectCategories,
  selectById: selectCategoryById,
  selectIds: selectCategoriesIds,
  selectEntities: selectCategoriesEntities,
} = categoriesAdapter.getSelectors((state: RootState) => state.categories);

export const selectCategoryName = createSelector(
  [selectCategoriesEntities, (state: RootState, categoryId?: string) => categoryId],
  (entities, categoryId) => {
    const category = categoryId ? entities[categoryId] : null;

    return category ? getCategoryName(category) : '-';
  },
);

export const selectCategoryIcon = createSelector(
  [selectCategoriesEntities, (state: RootState, categoryId?: string) => categoryId],
  (entities, categoryId) => {
    const category = categoryId ? entities[categoryId] : null;
    return category ? category.icon : null;
  },
);
